export class WebhookV1StandardPayloadCreditsMonthlyUsageArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "creditsMonthlyUsageNotification",
            "baseName": "creditsMonthlyUsageNotification",
            "type": "WebhookV1CreditsMonthlyUsageNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadCreditsMonthlyUsageArguments.attributeTypeMap;
    }
    constructor() {
    }
}
